module.exports = __webpack_public_path__ + "img/album07_32.969f0ea5.jpg";